export const ServiceReminderHeader = {
  userId: '6',
  displayMode: 'email',
  category: 'Heading',
  tags: [],
  data: {
    cells: [50.37, 49.63],
    columns: [
      {
        contents: [
          {
            type: 'text',
            values: {
              containerPadding: '10px',
              anchor: '',
              textAlign: 'left',
              lineHeight: '140%',
              linkStyle: {
                inherit: true,
                linkColor: '#0000ee',
                linkHoverColor: '#0000ee',
                linkUnderline: true,
                linkHoverUnderline: true,
              },
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_text',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
              text: '<p style="font-size: 14px; line-height: 140%;"><span style="font-size: 26px; line-height: 36.4px; ">A Friendly Reminder<br /><span style="font-size: 16px; line-height: 22.4px;">From {{clinic.name}}</span><br /></span></p>',
            },
          },
          {
            type: 'image',
            values: {
              containerPadding: '10px',
              anchor: '',
              src: {
                url: 'https://s3.us-east-2.amazonaws.com/unlayer-email-template-assets/1669768617850-reminder_sticker.png',
                width: 446,
                height: 140,
              },
              textAlign: 'center',
              altText: '',
              action: {
                name: 'web',
                values: {
                  href: '',
                  target: '_blank',
                },
              },
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_image',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          _meta: {
            htmlClassNames: 'u_column',
          },
          border: {
            borderTopStyle: 'solid',
            borderTopWidth: '0px',
            borderLeftStyle: 'solid',
            borderLeftWidth: '0px',
            borderRightStyle: 'solid',
            borderRightWidth: '0px',
            borderBottomStyle: 'solid',
            borderBottomWidth: '0px',
          },
          padding: '0px',
          borderRadius: '0px',
          backgroundColor: '',
        },
      },
      {
        contents: [
          {
            type: 'image',
            values: {
              containerPadding: '10px',
              anchor: '',
              src: {
                url: 'https://s3.us-east-2.amazonaws.com/unlayer-email-template-assets/1669767917618-cat_reminder.png',
                width: 878,
                height: 522,
                maxWidth: '100%',
                autoWidth: true,
              },
              textAlign: 'center',
              altText: '',
              action: {
                name: 'web',
                values: {
                  href: '',
                  target: '_blank',
                },
              },
              hideDesktop: false,
              displayCondition: null,
              _meta: {
                htmlClassNames: 'u_content_image',
              },
              selectable: true,
              draggable: true,
              duplicatable: true,
              deletable: true,
              hideable: true,
            },
          },
        ],
        values: {
          _meta: {
            htmlClassNames: 'u_column',
          },
          border: {
            borderTopStyle: 'solid',
            borderTopWidth: '0px',
            borderLeftStyle: 'solid',
            borderLeftWidth: '0px',
            borderRightStyle: 'solid',
            borderRightWidth: '0px',
            borderBottomStyle: 'solid',
            borderBottomWidth: '0px',
          },
          padding: '20px 0px 0px',
          borderRadius: '0px',
          backgroundColor: '',
        },
      },
    ],
    values: {
      displayCondition: null,
      columns: false,
      backgroundColor: '',
      columnsBackgroundColor: '',
      backgroundImage: {
        url: 'https://s3.us-east-2.amazonaws.com/unlayer-email-template-assets/1669768187005-v_background.png',
        fullWidth: false,
        repeat: 'no-repeat',
        size: 'custom',
        position: 'top-left',
        width: 1106,
        height: 444,
        customPosition: ['0%', '0%'],
      },
      padding: '0px',
      anchor: '',
      hideDesktop: false,
      _meta: {
        htmlClassNames: 'u_row',
      },
      selectable: true,
      draggable: true,
      duplicatable: false,
      deletable: true,
      hideable: true,
    },
    schemaVersion: 11,
  },
  custom: true,
};
